import { Component } from 'react';
import { Button, FormControl } from 'react-bootstrap';
import { createInstructionMarkup, questionComponentPropTypes } from './helpers';
import Immutable from 'immutable';

class FreeTextQuestion extends Component {
  handleResponseChange = (e) => {
    this.props.onResponseChange(
      this.props.response.set('answer', e.target.value)
    );
  };

  render = () => {
    const { question, response, onSaveClick, isSaving } = this.props;
    return (
      <div className="question text-question">
        <span dangerouslySetInnerHTML={createInstructionMarkup(question)} />
        <FormControl
          componentClass="textarea"
          rows={question.get('textarea_height')}
          placeholder="Write your answer"
          value={response?.get('answer')}
          onChange={this.handleResponseChange}
        />
        <Button
          onClick={onSaveClick}
          disabled={!response?.get('answer') || isSaving}
        >
          Save &amp; Continue
        </Button>
      </div>
    );
  };
}

FreeTextQuestion.propTypes = questionComponentPropTypes;
FreeTextQuestion.defaultProps = {
  response: Immutable.Map(),
};

export default FreeTextQuestion;
